export const PLAN_NAMES = {
  GOOD: 'Good',
  BETTER: 'Better',
  BEST: 'Best'
};
